module.exports = __webpack_public_path__ + "fonts/icomoon.66e1b89.woff";